<template>
    <transition name="slide">
        <div>
            <div class="row filters p-3">
                <div class="col-md-3 text-left order-2">
                    <div class="form-group m-0">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <button class="btn" @click="(month > 1) ? month-- : false">
                                    <font-awesome-icon icon="chevron-left"></font-awesome-icon>
                                </button>
                            </div>
                            <select class="form-control" v-model="month">
                                <option v-for="m in months" :value="m.index" :key="m.index">{{m.description}} {{year}}</option>
                            </select>
                            <div class="input-group-append">
                                <button class="btn" @click="(month < 12) ? month++ : false">
                                    <font-awesome-icon icon="chevron-right"></font-awesome-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 text-left order-2 invisible-sm">
                    <button class="btn btn-outline-azure" @click="month = new Date().getMonth() + 1" :disabled="month == new Date().getMonth() + 1">Huidige maand</button>
                </div>
                <div class="col-12 col-md-6 text-right mt-2 mb-1 p-0 order-1 order-md-3">
                    <div class="year d-inline-block pr-3" v-for="y in years" :value="y" :key="y">
                        <a href="#" @click="year = y" >{{y}}</a>
                    </div>
                </div>
            </div>
            <div class="row calendar p-0">
                <div :class="[(show) ? 'col-4 col-md-9' : 'col']">
                    <div v-if="isLoading" class="text-center vert-center">
                        <loader  width="5rem"></loader>
                    </div>
                    <div v-else>
                        <div class="row d-none d-md-flex">
                            <div class="col header-label pt-3" v-for="d in weekdays" :key="d">
                                {{d}}
                            </div>
                        </div>
                        <div v-for="w in weeks" :key="w.id">
                            <div class="row">
                                <button 
                                @click="toggle(d, w)" 
                                :class="['col', 'day', { 'disabled d-md-block': (!d.visible || (weeksInAdvance != 0 && d.date > advanceDate)), 'blocked': d.blocked, 'selected': !!date && d.date == date.date }]" 
                                v-for="d in days.filter((d) => d.week == w.id)" :key="d.index" 
                                :disabled="(!d.visible || (weeksInAdvance != 0 && d.date > advanceDate))">
                                    <span class="label">{{d.date.getDate()}}</span>
                                    <span class="rate">{{d.rate}}</span>
                                </button>
                            </div>
                            <transition name="slide">
                                <slot name="detail">
                                    <calendar-detail v-if="w.show" :date="date" @close="toggle" @blocked="block" :demo="demo"></calendar-detail>
                                </slot>
                            </transition>
                        </div>
                    </div>
                </div>
                <transition name="slide">
                    <div class="col-8 col-md-3 side" v-if="show && !!date">
                        <calendar-side :date="date" @close="toggle" @blocked="block" ></calendar-side>
                    </div>
                </transition>
            </div>
            <div class="row" v-if="this.$store.getters.user != null">
                <div class="form-group mt-5">
                    <label class="form-label">Beschikbaarheid in weken vooruit?</label>
                    <input type="number" class="form-control" v-model="weeksInAdvance" @change="saveWeeksInAdvance" />
                    <small>0 = onbeperkt</small>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Loader from '@/components/Loader'
import CalendarDetail from '@/components/CalendarDetail'
import CalendarSide from '@/components/CalendarSide'
export default {
    name: 'calendar',
    props: {
        demo: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    components: {
        Loader,
        CalendarSide,
        CalendarDetail
    },
    data() {
        return {
            isLoading: true,
            show: false,
            date: null,
            weeksInAdvance: !!this.$store.getters.user ? this.$store.getters.user.weeksInAdvance : 4,
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            months: [
                { index: 1, description: 'Januari' },
                { index: 2, description: 'Februari' },
                { index: 3, description: 'Maart' },
                { index: 4, description: 'April' },
                { index: 5, description: 'Mei' },
                { index: 6, description: 'Juni' },
                { index: 7, description: 'Juli' },
                { index: 8, description: 'Augustus' },
                { index: 9, description: 'September' },
                { index: 10, description: 'Oktober' },
                { index: 11, description: 'November' },
                { index: 12, description: 'December' },
            ],
            week: null,
            weeks: [],
            weekdays: ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'],
            days: [],
            years: [ new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear() + 1]
        }
    },
    mounted() {
        return this.setDays().then(() => {
            this.getDays(this.month);
        });
    },
    methods: {
        toggle(d, w) {
            if(this.date == d && w.show)
                return w.show = false;

            this.date = d;
            this.week = w;
            let weeks = this.weeks.filter((c) => { return c.show });
            weeks.forEach((c) => { return c.show = false });
            setTimeout(() => {
                return w.show = !w.show;
            }, 1);
        },
        block(block) {
            this.date.blocked = block;
        },
        setDays() {
            return new Promise((resolve, reject) => {
                this.isLoading = true;
                this.days = [];
                let firstDay = new Date(this.year, this.month - 1, 1),
                    lastDay = new Date(this.year, this.month, 0),
                    week = 0;

                for (var d = 1 - ((firstDay.getDay() == 0) ? 6 : firstDay.getDay() - 1); d <= lastDay.getDate() + ((lastDay.getDay() > 0 ) ? 7 - lastDay.getDay() : 0); d++) {
                    let date = new Date(this.year, this.month - 1, d);
                    if(date.getDay() === 1)
                        week++;

                    this.days.push({
                        index: d,
                        visible: (date.getMonth() != this.month - 1 || date < new Date()) ? false : true,
                        blocked: false,
                        date: date,
                        week: week,
                        rate: null,
                        show: false,
                        availability: { day: true, evening: true, night: true },
                        dayOfWeek: date.getDay()
                    });
                }
                return resolve();
            });
        },
        getDays(month) {
            if(this.demo)
            {
                return new Promise((resolve, reject) => { 
                    this.isLoading = false; 
                    resolve(); 
                });
            }

            return this.$http.get('api/Rates/' + month).then((res) => {
                res.data.forEach((r) => {
                    let day = this.days.find((c) => c.date.toDateString() == new Date(r.date).toDateString());
                    if(day) {
                        day.blocked = r.blocked;
                        day.rate = r.rate;
                        day.availability = r.availability;
                    }
                });
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        setWeeks() {
            let weeks = [];
            for(var i = 0; i <= Math.ceil(this.days.length / 7); i++)
            {
                weeks.push({ id: i, show: false });
            }
            return this.weeks = weeks;
        },
        saveWeeksInAdvance() {
            if(!this.weeksInAdvance || this.weeksInAdvance == '')
                this.weeksInAdvance = 0;

            this.$http.post('api/User/SaveWeeksInAdvance', this.weeksInAdvance).then((res) => {
                let user = Object.assign({}, this.$store.getters.user);
                this.weeksInAdvance = res.data;
                user.weeksInAdvance = res.data;
                this.$store.commit('SET_USER', user);
            });
        },
    },
    computed: {
        advanceDate() {
            let date = new Date();
            return new Date(date.setDate(date.getDate()+ ((parseInt(this.weeksInAdvance) * 7))));
        }
    },
    watch: {
        days(val) {
            this.setWeeks();
        },
        month(val) {
            this.show = false;
            return this.setDays().then(() => {
                this.getDays(this.month);
            });
        },
        year(val) {
            this.show = false;
            return this.setDays().then(() => {
                this.getDays(this.month);
            });
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/transitions.scss";
.day
{
    background-color: white;
    border: .5px solid lightgray;
    height: 100px;
    cursor: pointer;

    .label {
        position: absolute;
        top: .3rem;
        left: .5rem;
        margin: auto;
    }
}

.header-label {
    color: lightgray;
}

@media only screen and (max-width: 768px) {
  .day {
    height: 35px;
  }
}


.day:focus{
    outline: none;
}

.day.selected {
    background-color: $lightColor;
    border: 1px solid $darkColor;
}

.day.blocked {
    background: linear-gradient(to bottom right, #fff calc(50% - 1px), #aaa, #fff calc(50% + 1px) );
}
.day.blocked.selected {
    background: linear-gradient(to bottom right, $lightColor calc(50% - 1px), #aaa, $lightColor calc(50% + 1px) );
}
.day.disabled
{
    background-color: lightgray;
}
.day.disabled.blocked
{
    background: linear-gradient(to bottom right, lightgray calc(50% - 1px), #aaa, lightgray calc(50% + 1px) )
}

.side {
    border-left: .5px solid lightgray;
}

.calendar,
.filters {
    border: .5px solid lightgray;
}

.filters {
    border-bottom: none;
}

/*
.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: 'ease-out';
   -webkit-transition-timing-function: 'ease-out';
   -o-transition-timing-function: 'ease-out';
   transition-timing-function: 'ease-out';
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   overflow: hidden;
   flex: 25%;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   flex: 0;
}
*/
</style>